import { render, staticRenderFns } from "./resource-modal.vue?vue&type=template&id=0c8b28d1"
import script from "./resource-modal.vue?vue&type=script&lang=js"
export * from "./resource-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports